export default "__VITE_ASSET__BkPlASLC__"